import { toast } from "react-toastify";

const initState = {
  loading: false,
  transactions: [],
};

const transactionReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_TRANSACTIONS":
      return {
        ...state,
        loading: false,
        transactions: action.payload.sort(function (a, b) {
          if (a.timestamp !== undefined && b.timestamp !== undefined) {
            return a.timestamp.toDate() < b.timestamp.toDate()
              ? 1
              : b.timestamp.toDate() < a.timestamp.toDate()
              ? -1
              : 0;
          } else {
            return 0;
          }
        }),
      };

    case "GET_TRANSACTIONS_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        loading: false,
      };

    case "LOAD_TRANSACTIONS":
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};

export default transactionReducer;
